import { errorHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { getPath, Path } from 'urlBuilder';

export const getFinalUrl = (uiState: domain.OAuthUiState, companyId: string) => {
    if (uiState.type !== 'oauth') return '';

    switch (uiState.finalPage) {
        case 'workflow':
            return getPath(Path.companyWorkflows, companyId);
        case 'company':
            return getPath(Path.companyInfo, companyId);
        default:
            throw errorHelpers.assertNever(uiState.finalPage);
    }
};
